import Vue from 'vue';
import cookies from 'js-cookie';
// import Toast from 'service/comp/toast';
import utils from '@/utils';
import store from '@/store';
// @ts-ignore
import AliTracking from '@aixuexi/ali-tracking';
import DataTrack from '@/utils/dataTrack.json';
import packageInfo from '../../package.json';
import '@/assets/style/antd-reset.scss';
import '@/assets/iconfonts/fonts1/iconfont.css';
import '@/assets/iconfonts/fonts2/iconfont.css';

enum Status{
    noPermission = 403, // 无权限
    rightPermission = 200, // 有权限
    aboutToFreeze = 3, // 即将冻结
    freeze = 0, // 账号冻结
    aboutToExpired = 1, // 即将到期
    expired = 2, // 到期
    ctsExpired = 5, // 纯助教，cts权限过期
    tsmNewNT = 6, // 当前账号为三星个体老师机构TSM，且无教师或助教角色
}
// 创建埋点需要的标识
function createMaidian(userInfo: any = null) {
  const $dom = document.getElementById('maidian_page');
  let $maidianPage;
  /* eslint-disable @typescript-eslint/camelcase */
  Vue.prototype.$track = new AliTracking(DataTrack);
  Vue.prototype.$track.initBaseInfo({
    system: '爱学习web端',
    system_version: packageInfo.version,
    institution: userInfo.insId,
    user_id: userInfo.userId,
  }, { insName: userInfo.insFullName, roles: userInfo.roles }); // 初始化埋点
  /* eslint-enable @typescript-eslint/camelcase */
  if (!$dom) {
    $maidianPage = document.createElement('div');
    $maidianPage.id = 'maidian_page';
    $maidianPage.setAttribute('data-uid', userInfo ? userInfo.userId : '');
    $maidianPage.style.display = 'none';
    document.body.appendChild($maidianPage);
  } else {
    $maidianPage = $dom;
    $maidianPage.setAttribute('data-uid', userInfo ? userInfo.userId : '');
    $maidianPage.style.display = 'none';
  }
}

/**
   * 埋点操作data-pad
   */
function setPageId(to: any) {
  const { meta } = to;
  // const pad = to.meta.pad;
  const pathname = utils.getPathName();
  const pad = utils.getPad(pathname, to.name);
  const { query } = to;

  if (meta.maidian_skip) {
    return;
  }
  if (pad) {
    const domMaidian = document.getElementById('maidian_page');
    if (domMaidian) {
      domMaidian.setAttribute('data-pad', pad);
    }
    if (query && domMaidian) {
      domMaidian.setAttribute('data-pp1', encodeURIComponent(JSON.stringify(query)));
    }
    if (!document.getElementById('alilogJs')) {
      utils.appendScript('alilogJs', '//resource.aixuexi.com/alilog.v2.js')
        .then(() => {
          window.TrackerUtil.send_track(document.getElementById('maidian_page'));
        });
    } else {
      window.TrackerUtil.send_track(document.getElementById('maidian_page'));
    }
  }
}

function wmInitUser(userInfo: any) {
  window.localStorage.wmUserInfo = JSON.stringify({ userId: userInfo.userId, projectVersion: '1.0.0' });
}

/**
 * router加载之前执行
 * @param {Object} to to
 * @param {Object} from from
 * @param {Function} next next
 * @returns {Null} null
 */
async function beforeEach(to: any, from: any, next: any) {
  const token = cookies.get('token');
  // passport token
  const ptpc = cookies.get('ptpc');
  if (to.meta.allowNoLogin) {
    createMaidian();
    next();
    return;
  } if (!token && !ptpc) {
    const loginBackUrl = window.location.href;
    window.location.href = `//www.aixuexi.com/logout?loginBackUrl=${encodeURIComponent(loginBackUrl)}`;
    // window.location.href = '//www.aixuexi.com/logout.html';
  }
  try {
    const result = await store.dispatch('user/getPageAccess');
    store.commit('user/upateAccountStatus', result.status);
    if (result.remoteLoginCount !== undefined && result.remoteLoginCount !== null) {
      store.commit('user/updateRemoteLoginCount', result.remoteLoginCount);
    }
    // mock数据;
    // store.commit('user/updateRemoteLoginCount', 4);
    /* result.status 备注：
      403 无权访问;
      200 帐号正常无需拦截;
      0 帐号已冻结 ;
      3 帐号即将冻结；
      1 即将到期 ;
      2 帐号已到期 ;
      4 TSM账号过期，但是cts合作正常 ;
      5 角色中只有双师助教，并且助教已过期
      6 当前账号为三星个体老师机构，且无教师和助教角色
    */
    /* result.info 备注：status =1 帐号将要到期的时间, status = 3 距离帐号冻结还差几天 ;其他状态放空字符串 */
    if (result.status !== Status.noPermission) {
      const userInfoTemp = (store as any).state.user.userInfo;

      let userInfo;
      let classNumInfo;
      let guideOptions;
      if (userInfoTemp.userId) {
        userInfo = (store as any).state.user.userInfo;
        classNumInfo = userInfo.classNumInfo;
      } else {
        // 获取用户信息
        userInfo = await store.dispatch('user/fetchUserInfo');
        if (result.status === Status.expired) {
          classNumInfo = await store.dispatch('user/getClassNum');
          userInfo = {
            ...userInfo,
            pageAccess: result,
            classNumInfo,
          };
        } else {
          // 获取班级数量
          classNumInfo = await store.dispatch('user/getClassNum');
          // 获取新手引导
          guideOptions = await store.dispatch('user/getGuideOption');

          userInfo = {
            ...userInfo, pageAccess: result, classNumInfo, guideOptions,
          };
        }

        await store.commit('user/updateUserInfo', userInfo);
      }
      wmInitUser(userInfo);
      createMaidian(userInfo);
      const isTeacher = userInfo.roles.indexOf('teacher') !== -1;
      const isManage = userInfo.roles.indexOf('manage') !== -1;
      const isSuperManage = userInfo.roles.indexOf('super_manager') !== -1;
      const isDt = userInfo.roles.indexOf('dt_assistant') !== -1;
      const isAssistant = userInfo.roles.indexOf('assistant') !== -1;

      // 角色中只有双师助教，并且助教已过期
      if ((result.status === Status.ctsExpired || result.status === Status.tsmNewNT) && to.name !== 'unauthorized') {
        window.location.href = 'unauthorized.html';
        return;
      }
      if (result.signType === 2) {
        if ((isTeacher && result.status === Status.expired) || !isTeacher) {
          if ((isAssistant || isDt) && classNumInfo.classNum > 0) {
            next();
          } else {
            window.localStorage.setItem('signType2Status', !isTeacher ? '6' : '0');
            if (to.name !== 'unauthorized') {
              window.location.href = 'unauthorized.html';
            } else {
              next();
            }
          }
        }
      }
      // 只有双师助教没有教师和管理员，并且没有班级时，提示创建班级
      if (result.status === Status.rightPermission && isDt && !isManage && !isSuperManage && !isTeacher && classNumInfo.classNum === 0 && window.location.pathname.indexOf('createClass') === -1) {
        window.location.href = `${process.env.VUE_APP_JUMPURL}/createClass.html#/index?isDt=true`;
      }

      // 账号到期或者没有教师角色的管理员
      if ((result.status === Status.expired || (!isTeacher && !isDt && isManage && !isSuperManage)) && to.name !== 'unauthorized') {
        // 1.8.7教师+助教权限
        if (isTeacher && (isAssistant || isDt)) {
          next();
          // if (result.signType === 2 && classNumInfo.classNum < 1) {
          //   window.location.href = 'unauthorized.html';
          // } else {
          //   next();
          // }
        } else {
          window.location.href = 'unauthorized.html';
        }
      } else {
        next();
      }
    } else {
      const loginBackUrl = window.location.href;
      window.location.href = `//www.aixuexi.com/logout?loginBackUrl=${encodeURIComponent(loginBackUrl)}`;
      // window.location.href = '//www.aixuexi.com/logout.html';
    }
  } catch (error) {
    next();
  }
}

/**
   * router加载之前执行
   * @param {Object} to current router
   * @param {Object} from last router
   * @returns {Null} null
   */
function afterEach(to: any) {
  let checkTimer: number = 0;
  //   const { userInfo } = store.state.user;
  // 当有用户信息时给 sentry 设置用户信息
  // Sentry.setUser({ ...userInfo});
  setTimeout(() => {
    setPageId(to);
  }, 0);
  // 每5分钟轮询一下接口，防止用户信息被盗用
  if (!checkTimer && !to.meta.allowNoLogin) {
    checkTimer = setInterval(() => {
      store.dispatch('common/maintainLogin');
    }, 1000 * 60 * 5);
  }
}

export {
  beforeEach,
  afterEach,
};
